import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

import en from 'vuetify/es5/locale/en';
import cs from 'vuetify/es5/locale/cs';

export default new Vuetify({
    lang: {
        locales: {cs, en},
        current: 'cs' // TODO change based on user's locale
    }
});
